import React from 'react';
import { Text, Image, Rect } from 'react-konva';
import {
  isMobileTablet,
  isMobilePhone,
} from '../../library/calc';
import { editTreeActionIconTop, editTreeActionOpacity, fontFamily} from '../../library/constants';

export class Edit extends React.Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `edit_n-${this.props.n}`, objClass: this});
  }

  state = {
    hovering: false,
  }

  callHover(hover){
    this.setState({hover})
  }

  click(){

    if(isMobilePhone() ) return;
    this.props.stopStageClickPropagation({fromWhere: 'EditComponent'});
    this.props.onClickEdit(this.props.nodeObj.n);

  }

  render() {

    let {
      focus,
      left,
      top,
      editNodeImg,
      isPedigree,
      pedigreeIsTall
    } = this.props;

    const pedigreeTop = ( pedigreeIsTall ? -8: -14);
    top += editTreeActionIconTop + ( isPedigree ? pedigreeTop: 0);
    left += (focus ? 64.6: 57.8);
    left = left - 1;

    return <Image
            ref={'editNodeCache'}
            listening={false}
            image={editNodeImg}
            onClick={this.click.bind(this)}
            scaleX={.1}
            scaleY={.1}
            x={left}
            y={top}
            width={3.7 * 10}
            height={3.3 * 10}
            opacity={( ( this.state.hover ? 1: editTreeActionOpacity) )}
    />;
  }
}




export class TransparentEditBox extends React.Component {

  render () {

    let {
      focus,
      n,
      left,
      top,
      cursorBecomesMove,
      cursorBecomesPointer,
      onClickEdit,
      stopStageClickPropagation,
      userTouchedNode,
      isPedigree,
      pedigreeIsTall,
    } = this.props;

    const pedigreeTop = ( pedigreeIsTall ? -8: -13);
    top += editTreeActionIconTop + ( isPedigree ? pedigreeTop: 0);

    left +=( focus ? 64.6: 57.8);
    top -= 2;
    left -= 1.7;

    return  <Rect
              x={left}
              y={top}
              width={6}
              height={8}
              cursor="pointer"
              perfectDrawEnabled={false}
              onTouchStart={()=>{
                userTouchedNode({
                  node:n,
                  callback: ()=>{
                    if(isMobileTablet()) {
                      onClickEdit(n);
                    }
                  },
                  fromWhere: 'edit transparent component'
                });
              }}

              onClick={()=>{
                if(isMobilePhone() ) return;
                stopStageClickPropagation({fromWhere: 'EditComponent'});
                onClickEdit(n);
              }}

              onMouseenter={()=>{
                const hovering = true;
                this.props.callRefObj({key: `edit_n-${this.props.n}`, method: 'callHover', param: hovering})
                cursorBecomesPointer();
              }}
              onMouseleave={()=>{
                const hovering = false;
                this.props.callRefObj({key: `edit_n-${this.props.n}`, method: 'callHover', param: hovering})
                cursorBecomesMove();
              }}

            />

  }
}

export class Delete extends React.Component {
  render() {

    let {
      n,
      left,
      top,
      cursorBecomesMove,
      cursorBecomesPointer,
      onClickDelete,
      stopStageClickPropagation,
      userTouchedNode,
    } = this.props;
    left += 55;
    top += .8;

    const width = 27;
    const fontSize = 6;

    return <Text
      x={left}
      y={top}
      text={'X'}
      width={width}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fill='red'

      onTouchStart={()=>{
        userTouchedNode(n, ()=>{
          if(isMobileTablet()) onClickDelete(n);
        }, 'delete component');
      }}

      onClick={()=>{
        if(isMobilePhone() ) return;
        stopStageClickPropagation({fromWhere: 'DeleteComponent'});
        onClickDelete(n);
      }}

      onMouseenter={()=>{
        cursorBecomesPointer();
      }}
      onMouseleave={()=>{
        cursorBecomesMove();
      }}

    />;
  }
}
